// extracted by mini-css-extract-plugin
export default {"componentHolder":"DeliveryInfo_componentHolder__ez2hk","infoHolder":"DeliveryInfo_infoHolder__noxuy","btnHolder":"DeliveryInfo_btnHolder__oVE3t"};